import { AppContent } from '../AppContent';

// FullSignatoryPage content for LBG
const redirect: AppContent['redirect'] = {
  redirectContent: [
    {
      description: 'This is a dummy page',
    },
  ],
};

export default redirect;
